import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
	mutation Login($input: LoginInput!) {
		login(input: $input) {
      jwtBearer
      jwtRefresh
      user {
        id
        fullName
        email
        admin
        birthDate
        hireDate
        jobTitle
        ssn
			  personal
        officeId
        role
        bio
        phone
        fax
        emergency
        avatar
        social
        state
      }
		}
	}
`;